import { MoneyInput } from '@/components';
import { Dispatch } from 'react';
import { Label } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { ZieleEditForm, ZieleFormReducerAction } from '../types';
import { FormFieldWrapper } from '@/domain/controlling/pages/Umsatzplanung/components/FormFieldWrapper';

export function UmsatzzielInputFields({
  dispatch,
  zieleForm,
}: {
  dispatch: Dispatch<ZieleFormReducerAction>;
  zieleForm: ZieleEditForm;
}) {
  const { t } = useTranslation();

  function handleUpdateUmsatzZiel(value: string) {
    dispatch({
      type: 'updateUmsatzZiel',
      values: {
        umsatzZiel: value,
      },
    });
  }

  function handleUpdateUmsatzZielproduktivitaet(value: string) {
    dispatch({
      type: 'updateUmsatzZielproduktivitaet',
      values: {
        umsatzZielproduktivitaet: value,
      },
    });
  }

  return (
    <div className="flex justify-between gap-4">
      <FormFieldWrapper>
        <Label htmlFor="umsatzZiel">
          {t('domain.controlling.umsatzplanung.ziele.dialog.umsatz.label')}
        </Label>
        <MoneyInput
          id="umsatzZiel"
          value={zieleForm.formValues.umsatzZiel}
          onInput={(event) => handleUpdateUmsatzZiel(event.currentTarget.value)}
          onBlur={(event) => handleUpdateUmsatzZiel(event.currentTarget.value)}
        />
      </FormFieldWrapper>
      <FormFieldWrapper>
        <Label>
          {t(
            'domain.controlling.umsatzplanung.ziele.dialog.produktivitaet.label',
          )}
        </Label>
        <MoneyInput
          id="umsatzZiel"
          value={zieleForm.formValues.umsatzZielproduktivitaet}
          onInput={(event) =>
            handleUpdateUmsatzZielproduktivitaet(event.currentTarget.value)
          }
          onBlur={(event) =>
            handleUpdateUmsatzZielproduktivitaet(event.currentTarget.value)
          }
          isIconVisible={false}
          unit={t('domain.controlling.umsatzplanung.units.€/Std.')}
        />
      </FormFieldWrapper>
    </div>
  );
}
